import { render } from "./Index.vue?vue&type=template&id=23c5bfe0"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render

export default script